module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n        返回抽成列表\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('select', {
    staticClass: "form-control h-38",
    staticStyle: {
      "max-width": "140px"
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("下訂時間")])]), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5 w-120"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.startDate,
      "enabled": _vm.isLoading,
      "option": _vm.dateoption,
      "limit": _vm.dateLimit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5 w-120"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.endDate,
      "enabled": _vm.isLoading,
      "option": _vm.dateoption,
      "limit": _vm.dateLimit
    }
  })], 1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterType),
      expression: "filterType"
    }],
    staticClass: "form-control h-38 m-l-15",
    staticStyle: {
      "max-width": "140px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("訂單狀態")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("取餐類型")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("付款類型")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group h-38"
  }, [(_vm.filterType === 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderSN),
      expression: "orderSN"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "170px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderSN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderSN = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filterType === 2) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "170px"
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statusList), function(status) {
    return _c('option', {
      key: status.value,
      domProps: {
        "value": status.value
      }
    }, [_vm._v("\n                    " + _vm._s(status.label) + "\n                  ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.filterType === 3) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deTypeSelect),
      expression: "deTypeSelect"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "170px"
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.deliveryTypeList), function(type) {
    return _c('option', {
      key: type.value,
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n                    " + _vm._s(type.label) + "\n                  ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.filterType === 4) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trTypeSelect),
      expression: "trTypeSelect"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "170px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getTradeType), function(trade) {
    return _c('option', {
      key: trade.value,
      domProps: {
        "value": trade.value
      }
    }, [_vm._v("\n                    " + _vm._s(trade.label) + "\n                  ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": _vm.setQuery
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-inline m-t-10 flex align-end"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                門市資訊服務費抽成原金額: $" + _vm._s(_vm.totalCommissionMoney) + "\n              ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 m-b-10 text-right"
  }, [_c('button', {
    staticClass: "btn btn-default p-a-10",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": _vm.exportFile
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }, [_vm._v("下載報表")]), _vm._v(" "), _c('Clip', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(2)]) : (_vm.list.length === 0) ? _c('tbody', [_vm._m(3)]) : _c('tbody', _vm._l((_vm.list), function(row, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/orderInfo/' + row.order_id
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                        " + _vm._s(row.order_sn) + "\n                      ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.brand_name) + "(" + _vm._s(row.brand_id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.store_name) + "(" + _vm._s(row.store_id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("deliveryName")(row.delivery_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tradeName")(row.trade_type)))]), _vm._v(" "), _c('td', [(row.src_type === 1 || row.src_type === 3) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("P")]) : _c('span', {
      staticClass: "text-12 text-w-600 label-warning",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("D")]), _vm._v(" "), (row.sub_src_type === 1) ? _c('span', {
      staticClass: "text-12 text-w-600 label-default",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("W")]) : (row.sub_src_type === 2) ? _c('span', {
      staticClass: "text-12 text-w-600 label-success",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("L")]) : (row.sub_src_type === 3) ? _c('span', {
      staticClass: "text-12 text-w-600 label-primary",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("M")]) : (row.sub_src_type === 4) ? _c('span', {
      staticClass: "text-12 text-w-600 label-success",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("LI")]) : (row.sub_src_type === 5) ? _c('span', {
      staticClass: "text-12 text-w-600 label-danger",
      staticStyle: {
        "padding": "0px 3px"
      }
    }, [_vm._v("J")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("orderStatusName")(row.order_status)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.order_time))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(row.total_paid_money))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.commission_ratio) + "%")]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(row.total_finish_commission_money))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(row.total_void_commission_money))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(row.total_commission_money))])])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                抽成金額為訂單實付金額 * 抽成 %；採四捨五入計算\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌 (ID)")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店 (ID)")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("取餐類型")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款類型")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單來源")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單狀態")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("下訂時間")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("實付金額")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("抽成％")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已完成訂單資訊服務費抽成金額")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已作廢訂單資訊服務費抽成金額")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                      資訊服務費抽成金額\n                      "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "已完成+已作廢訂單資訊服務費抽成金額"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "14"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "14"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-088a35a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/VenderTradeTable/CommissionStore.vue
// module id = 2305
// module chunks = 1